import React, {useState,useEffect} from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams,useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import DropDownMenu from '../components/DropDownMenu';
import SearchSvg from '../../svg/admin/Search';
import AddSvg from '../../svg/admin/Add';
import MoreSvg from '../../svg/admin/More';
import PageSelector from '../components/PageSelector';
import { approveRegistration, fetchRegistrations, rejectRegistration } from '../../services2/registrations.service';
import {utils,writeFile} from 'xlsx';
function Component(props) {
  const {  } = useParams();
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const [data,setdata] = useState(null)
  const [isLoading,setisLoading]=useState(false)
  const [total,settotal]=useState(0)


  const status= searchParams.get('status')|| '全部';
  const page= parseInt(searchParams.get('page'))||1;
  const limit= 10
  const totalPage = Math.ceil(total/limit)||1

  const secarchText = searchParams.get('search')||''
  const handleSearch=(e)=>{
    searchParams.delete('search')
    searchParams.set('search', e.target.value)
    searchParams.set('page', 1)
    setSearchParams(searchParams)
  }

  const handleSelectPage=(p)=>async ()=>{
    if(p > totalPage || p < 1) return;
    searchParams.delete('page')
    searchParams.set('page', p)
    setSearchParams(searchParams)
}

  const fetchData=async()=>{
    const filter={}
    if(status!=='全部')filter.status=status
    if(secarchText)filter.schoolName={$regex:secarchText,$options:'i'}
    let result = await fetchRegistrations(props.token.token,filter,{limit,skip:(page-1)*limit,sort:{_id:-1}});
    if(result.result){
        setdata(result.result)
        settotal(result.count||0)
    }else{
        alert('Fetch data error')
    }
  }


  const onSelectFilter=(item,index)=>{
    searchParams.delete('status')
    searchParams.delete('page')
    searchParams.set('status', item)
    searchParams.set('page', 1)
    setSearchParams(searchParams)
  }

  const refresh=()=>{
    if(isLoading)return
    setisLoading(true)
    fetchData()
    setisLoading(false)
  }

  useEffect(() => {
    const timer = setTimeout(refresh, 500)
    //const interval = setInterval(refresh,1000*30)
    return () => {
        clearTimeout(timer)
        //clearInterval(interval)
    }
  },[searchParams])

  const openNewTab=(url)=>()=>{
    window.open(url, '_blank').focus();
  }

  const handleApproveRegistration=(item)=>async()=>{
    setisLoading(true)
    let result = await approveRegistration(props.token.token,item._id);
    if(result.errno===0){
        fetchData()
    }else{
        alert(JSON.stringify(result?.message)||'Approve error')
    }
    setisLoading(false)
  }
  const handleRejectRegistration=(item)=>async()=>{
    setisLoading(true)
    let result = await rejectRegistration(props.token.token,item._id);
    if(result.errno===0){
        fetchData()
    }else{
        alert(JSON.stringify(result?.message)||'Reject error')
    }
    setisLoading(false)
  }
  const handleDownload=async()=>{
    const filter={}
    if(status!=='全部')filter.status=status
    if(secarchText)filter.schoolName={$regex:secarchText,$options:'i'}
    let result = await fetchRegistrations(props.token.token,filter,{limit:9999,sort:{_id:-1}});
    if(result.result){
        let data = result.result
        const array = [
          ['學校名稱','學校電話', '學校傳真','校長姓名','負責老師','老師電話','老師電郵','登記狀態','備注','回條/通函報名表'],
        ];
        for(let item of data){
          array.push([
              item?.schoolName||'',
              item?.schoolTel||'',
              item?.schoolFax||'',
              item?.principalName||'',
              item?.teacherName||'',
              item?.teacherTel||'',
              item?.teacherEmail||'',
              item?.status||'',
              item?.remarks||'',
              item?.attachment||'',
          ])
        }
        const ws = utils.aoa_to_sheet(array);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, '學校資料');
        writeFile(wb, '學校資料.xlsx');
    }else{
        alert('Download error')
    }
  }


  return (
    <div className='h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px]'>
        {/*title, filter, serach box*/}
        <div className='p-[16px] flex flex-row items-center justify-between items-center bg-[white] rounded-[10px] gap-[8px] flex-wrap'>
            <div className='text-[#212121] text-[20px] font-[700]'>學校資料</div>
            <div className='flex flex-row items-center gap-[8px] flex-wrap'>
              <div onClick={handleDownload} className="text-[14px] py-[8px] px-[16px] rounded-[7px] gap-[4px] flex flex-row border-black border-[0.5px] cursor-pointer hover:opacity-[.5]">下載學校資料</div>
                <DropDownMenu select={onSelectFilter} value={status} options={['全部','未批准','已批准','已拒绝']}/>
                <div className='text-[14px] py-[8px] px-[16px] rounded-[7px] gap-[4px] flex flex-row' style={{border:'.5px solid #00000080'}}>
                    <SearchSvg/>
                    <input value={secarchText} onChange={handleSearch} placeholder='搜尋'/>
                </div>
            </div>
        </div>
        {/*end of title, filter, serach box*/}


        {/*list of data*/}
        <div className='flex flex-col flex-1 w-full bg-[white] rounded-[10px] p-[16px]  text-[14px]' style={{overflowY:'auto'}}>
            <div className='w-full flex flex-row justify-between font-bold py-[16px]' style={{borderBottom:'1px solid #D1D1D1'}}>
                <div className='flex-1'>學校名稱</div>
                <div className='flex-1'>學校電話</div>
                <div className='flex-1'>學校傳真</div>
                <div className='flex-1'>校長姓名</div>
                <div className='flex-1'>負責老師</div>
                <div className='flex-1'>老師電話</div>
                <div className='flex-1'>老師電郵</div>
                <div className='flex-1'>登記狀態</div>
                <div className='flex-1'>備注</div>
                <div className='flex-1'>回條/通函報名表</div>
                <div className='w-[32px]'></div>
                <div className='ml-[8px] w-[32px]'></div>
            </div>
            {data?.map((item,index)=>
                <div key={item?._id||index} className='w-full flex flex-row justify-between font-[400] py-[16px] items-center text-[12px]' style={{borderBottom:'1px solid #D1D1D1'}}>
                    <div className='flex-1'>{item?.schoolName}</div>
                    <div className='flex-1'>{item?.schoolTel}</div>
                    <div className='flex-1'>{item?.schoolFax}</div>
                    <div className='flex-1'>{item?.principalName}</div>
                    <div className='flex-1'>{item?.teacherName}</div>
                    <div className='flex-1'>{item?.teacherTel}</div>
                    <div className='flex-1'>{item?.teacherEmail}</div>
                    <div className='flex-1 flex flex-row'>
                      {item.status === '已批准' ? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#DBFFF0] text-[#4DE0A4]'>已批准</div>
                        : item.status === '未批准' ? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#cccccc99] text-[#000]'>未批准</div>
                          : item.status==='已拒绝'? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#FFC8C899] text-[#F06969]'>已拒绝</div>
                          :<div>{item.status}</div>
                      }
                    </div>
                    <div className='flex-1'>{item?.remarks||''}</div>

                    <div className='flex-1'>{item?.attachment?<img onClick={openNewTab(item.attachment)} className='w-[40px] h-[40px] cursor-pointer' src='/images/file_icon.png'/>:"no file"}</div>
                    <div onClick={handleApproveRegistration(item)} className='w-[32px] bg-[#D8FFD0] h-[32px] rounded-[5px] flex justify-center items-center cursor-pointer hover:opacity-[.5] text-[green]'>
                        ✓
                    </div>
                    <div onClick={handleRejectRegistration(item)} className='ml-[8px] w-[32px] bg-[#FFD8D0] h-[32px] rounded-[5px] flex justify-center items-center cursor-pointer hover:opacity-[.5] text-[red]'>
                        X
                    </div>
                </div>
            )}
        </div>
        {/*end of list of data*/}
        <PageSelector
            handleSelectPage={handleSelectPage}
            page={page}
            total={total}
            totalPage={totalPage}
        />

        {isLoading&&<LoadingPage/>}
    </div>
  );
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)
  